import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  ama,
  handleCancelClick,
  increment,
  setAmaId,
  amotMedaCat,
  amotMeda,
}) => {
  const [newAma, setNewAma] = useState(ama);
  const oldAmaMeshkal = ama.meshkal;
  const oldamot_meda_cat = ama.amot_meda_cat;
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);
  const totalMeshkal = amotMeda.reduce((a, b) => a + b.meshkal, 0);
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewAma((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);

    setNewAma((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "amotmeda/" + newAma.id + "/",
          newAma,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    saveData();
    // setDepart(null);
    setAmaId(null);
    setError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const searchAma = amotMeda.find(
      (ama) => ama.amot_meda_cat == newAma.amot_meda_cat
    );
    const max = "" + (100 - Number(totalMeshkal));
    if (searchAma && searchAma.amot_meda_cat !== oldamot_meda_cat)
      alert("אמת מידה זו הוגדרה כבר!!!");
    else if (
      Number(totalMeshkal) - Number(oldAmaMeshkal) + Number(newAma.meshkal) >
      100
    ) {
      alert(
        "לא ניתן לעדכן אמת מידה זו כי סיכום השיקלול גדול ממאה!!! המשקל המקסימלי לא יכול לעלות על " +
          max
      );
    } else {
      let isMounted = true;
      const controller = new AbortController();
      const saveData = async () => {
        try {
          const response = await axiosPrivate.put(
            baseURL + "amotmeda/" + newAma.id + "/",
            newAma,
            {
              signal: controller.signal,
            }
          );
          isMounted && increment();
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };

      saveData();
      // setDepart(null);
      setAmaId(null);
      setError(false);
    }
  };

  return (
    <tr>
      <td>{ama.id}</td>
      <td>
        <select
          name="amot_meda_cat"
          onChange={handleDDSChange}
          value={newAma.amot_meda_cat}
        >
          <option value="" selected>
            בחר קטגוריה
          </option>
          {amotMedaCat?.map((a) => (
            <option key={a.id} value={a.id}>
              {a.title}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="number"
          name="meshkal"
          className="form-control"
          id="meshkal"
          value={newAma.meshkal}
          placeholder="משקל"
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="number"
          name="tsion"
          className="form-control"
          id="tsion"
          value={newAma.tsion}
          placeholder="ציון"
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
